<script setup lang="ts">
import { FolderOpen } from "@lucide/vue"
import { useI18n } from "vue-i18n"

import { Button } from "@/shared/ui"

import { useServicesCatalogStore } from "../model/store"

const { t } = useI18n()
const store = useServicesCatalogStore()
</script>

<template>
  <div class="flex flex-col items-center justify-center gap-4 py-12 text-center">
    <div class="rounded-lg bg-accent p-4">
      <FolderOpen class="size-8 text-primary" />
    </div>

    <div class="space-y-2">
      <h3 class="font-semibold">{{ t("services.empty.firstRun.title") }}</h3>
      <p class="text-sm text-muted-foreground">{{ t("services.empty.firstRun.body") }}</p>
    </div>

    <Button
      data-testid="empty-state-cta"
      @click="store.openCategoryDraft()"
    >
      {{ t("services.empty.firstRun.cta") }}
    </Button>
  </div>
</template>
